import { Collapse as MuiCollapse } from "@mui/material";
import type { ReactNode } from "react";

type CollapseProps = {
  in: boolean;
  className?: string;
  id?: string;
  children: ReactNode;
};

export function Collapse({
  in: inProp,
  className,
  id,
  children,
}: CollapseProps) {
  return (
    <MuiCollapse in={inProp} id={id} className={className}>
      {children}
    </MuiCollapse>
  );
}
